import React from 'react';
import {
  cssColorValue,
  screenSmMin,
  screenMdMin,
  cssSpacing,
} from '@spotify-internal/encore-web';
import { Grid } from '@spotify-internal/frodor-modules';
import styled, { css } from 'styled-components';

const HeaderImage = styled(Grid)<{ isTall?: boolean }>`
  color: ${cssColorValue('textBase')};

  ${({ isTall }) => {
    return isTall
      ? css`
          min-height: 472px;
          @media (min-width: ${screenSmMin}) {
            min-height: 732px;
          }
          @media (min-width: ${screenMdMin}) {
            min-height: 772px;
          }
        `
      : css`
          min-height: 260px;
          @media (min-width: ${screenMdMin}) {
            min-height: 444px;
          }
        `;
  }}

  padding-bottom: ${cssSpacing('looser')};
  padding-top: 80px;
  position: relative;
`;

const Image = styled.div<{
  backgroundImage?: string;
  backgroundColor?: string;
}>`
  z-index: 1;
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: ${({ backgroundImage }) => backgroundImage};
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-position: center;
  background-size: cover;
  :after {
    content: ' ';
    position: absolute;
    background: black;
    opacity: 30%;
    height: 100%;
    width: 100%;
  }
`;

type Props = {
  backgroundImage: string;
  children: React.ReactNode;
  isTall?: boolean;
};
export const HeaderImageGrid = ({
  backgroundImage,
  isTall,
  children,
}: Props) => {
  return (
    <HeaderImage isTall={isTall}>
      <Image backgroundImage={backgroundImage} />
      {children}
    </HeaderImage>
  );
};
